<template>
  <GlobalHeader /> 
  <main id="main-content">
    <slot />
  </main>
  <GlobalFooter />
</template>

<script setup lang="ts"></script>
